<template>
  <label :for="`select-artifact-input-${parent}-${field.name}`">
    {{ field.label ? field.label : field.name }}
  </label>
  <select
    :id="`select-artifact-input-${parent}-${field.name}`"
    :value="modelValue"
    class="select"
    :disabled="!trainerId"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option :value="null" disabled selected>Select Artifact</option>
    <option
      v-for="(artifact, i) in artifacts"
      :key="`dropdown-${parent}-${field.name}-${i}-${artifact.name || artifact}`"
      :value="artifact.name || artifact"
    >
      {{ artifact.name || artifact }}
    </option>
  </select>
</template>

<script setup>
import {
  ref, onMounted, watch,
} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

const props = defineProps({
  parent: {
    type: String,
    default: 'profiler-val-session',
  },
  field: {
    type: Object,
    default: () => ({ name: 'artifact', label: 'Artifacts' }),
  },
  modelValue: {
    type: String,
    default: '',
  },
  trainerId: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['update:modelValue']);
const artifacts = ref([]);

async function getArtifacts(trainerId) {
  if (!trainerId) {
    artifacts.value = [];
    emit('update:modelValue', '');
    return;
  }

  try {
    const dataConnect = new DatastoreConnect();
    const response = await dataConnect.getTrainingSessionArtifacts({
      training_session_id: parseInt(trainerId, 10),
    });

    if (response.error) {
      throw response.error;
    }

    artifacts.value = response.result || [];
    const hasSelected = artifacts.value.some((artifact) => (artifact.name || artifact) === props.modelValue);
    if (!hasSelected) {
      emit('update:modelValue', artifacts.value[0]?.name || artifacts.value[0] || '');
    }
  } catch (error) {
    console.error('Error fetching artifacts:', error);
    artifacts.value = [];
    emit('update:modelValue', '');
  }
}

watch(() => props.trainerId, async (newTrainerId) => {
  await getArtifacts(newTrainerId);
}, { immediate: true });

onMounted(async () => {
  await getArtifacts(props.trainerId);
});
</script>
